package music.jammers.shared.event.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable
import music.jammers.shared.event.track.domain.model.EventTrack

@Serializable
data class EventDetails(
    val title: String,
    val date: LocalDateTime,
    val spot: String,
    val tracks: List<EventTrack>,
    val backlog: List<EventTrack>,
    val frozen: Boolean,
    val eventInstrumentList: List<EventInstrument>,
)